import React from 'react';

import OfferCard from '@components/pages/SubscribeTest/OfferSelection/OfferCards';
import OfferTable from '@components/pages/SubscribeTest/OfferSelection/OfferTable';
import { BENEFITS } from '@components/pages/SubscribeTest/OfferSelection/constants';
import { OfferOption } from '@utils/backend-api/subscribe';

interface OffersProps {
  offers: OfferOption[];
  onClickOffer: () => void;
  setSelectedOffer: (offer: OfferOption) => void;
  ypOffer: OfferOption;
}

const Offers = ({ offers, onClickOffer, setSelectedOffer, ypOffer }: OffersProps) => {
  return (
    <div className="mb-96">
      <div className="mb-64">
        <OfferTable
          benefits={BENEFITS}
          offers={offers}
          onOfferClick={onClickOffer}
          setSelectedOffer={setSelectedOffer}
        />
      </div>
      <OfferCard
        ypOffer={ypOffer}
        onOfferClick={onClickOffer}
        setSelectedOffer={setSelectedOffer}
        offerTitleClass="sm:!text-headline-xs"
      />
    </div>
  );
};

export default Offers;
